import React, { Fragment, useEffect, useState, forwardRef } from "react";
import { useAuth } from "../context/AuthContext";
import AsyncSelect from "react-select/async";

const DropDownTrustSelection = forwardRef(({
  defaultValue,
  onSelected,
  onTrusts = null,
  disabled = false,
  placeholderText = "All Trusts",
}, ref) => {
  const { authAxios } = useAuth();
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (defaultValue === null || defaultValue === undefined) return;
    setSelected({ value: defaultValue, label: defaultValue?.shortName });
  }, [defaultValue]);

  const fetchTrusts = async () => {
    try {
      const response = await authAxios().get("/api/trusts/");
      
      const data = response.data;
      
      // If onTrusts callback is provided, share all trusts data with parent
      if (onTrusts !== null) onTrusts(data);
      
      // Map trusts to react-select format
      const options = data.map(trust => ({
        value: trust, 
        label: trust.shortName
      }));
      
      return options;
    } catch (error) {
      console.log("Error fetching trusts");
      console.log(error);
      console.log(error.stack);
    }
    return [];
  };

  const selectTrust = (trustOption) => {
    setSelected(trustOption);
    onSelected(trustOption?.value);
  };

  const promiseOptions = () =>
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(fetchTrusts());
      }, 300);
    });

  // Expose methods to the parent component via ref
  React.useImperativeHandle(ref, () => ({
    reset: () => {
      setSelected(null);
      onSelected(null);
    }
  }));

  return (
    <Fragment>
      <AsyncSelect
        className={"fs-input"}
        cacheOptions
        loadOptions={promiseOptions}
        defaultOptions={true}
        isClearable={true}
        onChange={(data) => {
          selectTrust(data);
        }}
        value={selected}
        placeholder={placeholderText}
        isDisabled={disabled}
      />
    </Fragment>
  );
});

export default DropDownTrustSelection;
